import { useParams } from "react-router-dom";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "../../components/ui/Container/Container";
import { IconSvg } from "../../utils/constants/icons/iconSvg.constant";
import { ContentReducerActions } from "../../redux/reducers/ContentReducer/Content.reducer";
import { ApiService } from "../../services/ApiService";
import { useDebounceValue } from "../../hooks";
import { HeaderReducerActions } from "../../redux/reducers/HeaderReducer/Header.reducer";
import { BlogCategory } from "./components/BlogCategory/BlogCategory";
import "./BlogPage.scss";

const BlogPage = () => {
  const { lang } = useParams();
  const { blog: { groups } } = useSelector((state) => state.content);

  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounceValue(search, 500);

  const groupsByLocale = groups[lang] || [];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const groupsWithArticles = groupsByLocale?.filter(({ articles }) => articles.length > 0) || [];

  const filteredGroupsBySearch = useMemo(() => {
    if (!debouncedSearch) return groupsWithArticles;

    const lowerCasedSearch = debouncedSearch.toLowerCase();

    return groupsWithArticles
      .map((group) => {
        const filteredArticles = group.articles.filter((article) =>
          article.title.toLowerCase().includes(lowerCasedSearch)
        );

        return {
          ...group,
          articles: filteredArticles
        };
      })
      .filter((group) => group.articles.length > 0);
  }, [groupsWithArticles, debouncedSearch]);

  return (
    <div className="blog">
      <Container>
        <div className="blog__heading">
          <h1>{lang === "en" ? "Blog" : "Блог"}</h1>
          <div className="blog__input-container">
            <IconSvg tag="searchNew"/>
            <input
              placeholder={lang === "en" ? "Search in blog" : "Поиск в блоге"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="blog__container">
          {filteredGroupsBySearch.length > 0 ? (
            filteredGroupsBySearch.map((group) => (
              <BlogCategory key={group.id} group={group} />
            ))
          ) : (
            <div className="blog__empty">
              {lang === "en" ? "Nothing found for your search." : "Ничего не найдено по вашему запросу."}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

BlogPage.getServerSideState = async (store, params) => {
  const baseURL = process.env.REACT_APP_SSR_API_URL;

  const { data } = await ApiService.getBlogGroupsSSR(baseURL, params.locale);

  store.dispatch(ContentReducerActions.setBlogGroups({ lang: params.locale, data }));
  store.dispatch(HeaderReducerActions.setDarckTheme(params.theme));
};

export default BlogPage;
